var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, when, flow, makeObservable } from 'mobx';
import { QuestionPassStateId, QuestionTypeName, TrackIdent } from '../../learnware/LearnwareEnums';
import { runtime } from '../../runtime/Runtime';
import { xa } from '../../../utils/xa/xa';
export class DirectivePoseQuestion {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get directive() {
        return this.parent;
    }
    get app() {
        return this.directive.app;
    }
    get question() {
        return this.app.question;
    }
    async poseNextAnswerInLine() {
        if (this.app.appInfo.isMobileAppWebView) {
            return;
        }
        if (this.question && this.question.questionType === QuestionTypeName.CycleEnd) {
            return;
        }
        if (this.app.tray.funnel.funnelLine.funnelAnswers.length === 0) {
            this.app.message.info('Keine weitere Fragen in diesem Thema verfügbar.');
            return;
        }
        const { nextAnswer } = this.app.tray.funnel.funnelLine;
        await this.poseAnswer(nextAnswer);
    }
    async poseNextReward() {
        const nextReward = this.app.cycle.cycleReward.rewardAnswer;
        await this.poseAnswer(nextReward);
    }
    async poseAnswer(answer) {
        if (!answer)
            return;
        await when(() => !this.app.stage.stageEmerge.isCurrentlyEmerging);
        if (runtime.isServerRuntime)
            return;
        // console.log('stageItem', item);
        this.app.stage.stageEmerge.isCurrentlyEmerging = true;
        await this.stageAnswer(answer);
        this.app.stage.stageEmerge.isCurrentlyEmerging = false;
    }
    removeCurrentQuestionAndRePose = flow(function* () {
        const answer = this.app.answer;
        yield this.poseNextAnswerInLine();
    });
    async poseQuestionById(questionId) {
        const answer = this.app.tray.trayTransform.questionIdToAnswer(questionId);
        await this.poseAnswer(answer);
    }
    async stageAnswerById(answerId) {
        const answer = this.app.tray.trayAnswers.allAnswersInLine.find(answer => answer.id === answerId);
        await this.poseAnswer(answer);
    }
    stageAnswer = flow(function* (answer) {
        if (!this.app.appInfo.isMobileAppWebView) {
            runtime.solidBrowserRuntime.browserAddressBar.setQuestionToHashParameter(answer.question_id);
        }
        this.app.tray.trayTransform.reuseAnswersForMini.delete(answer.question_id);
        yield answer.answerPrepare.prepareAnswer();
        if (runtime.availablePackages.Exotic && this.app.aural) {
            if (this.app.recognition.isRecognitionRunning) {
                this.app.recognition.abortRecognition();
            }
            this.app.hear.resetAural();
        }
        console.log(`stageQuestion ${answer.question_id}`);
        this.app.stage.itemOnStage = answer;
        answer.poseDate = this.app.appClock.currentDate;
        // this.app.funnel.funnelPreload.preloadedNextAnswer = undefined;
        if (this.app.appInfo.isMobileAppWebView) {
            runtime.runtimeScheduler.addToNextIdleStateChange(() => this.app.api.apiNativeApp.sendReadyEventToWebView());
        }
        if (answer.question.questionType === QuestionTypeName.CycleEnd) {
            /* if (answer.miniQuestion) {
              answer.miniQuestion.miniPassState.setPassState(QuestionPassStateId.Passed);
            } */
            xa.personalTopic.setQuestionState({
                reason: QuestionPassStateId.Passed,
                timestamp: new Date().mysqlTimestamp,
                questionId: answer.question_id,
            });
        }
        if (!this.app.appInfo.isMobileAppWebView) {
            this.app.track.trackEvent({
                ident: TrackIdent.ShowQuestion,
                question_id: answer.question.id,
                answer_id: answer.id,
                value1: '1', // (this.app.cycle.currentCyclePosition + 1).toString(),
            });
            /*
            setTimeout(() => {
              runtime.runtimeScheduler.addToNextIdleStateChange(() => {
                this.app.funnel.funnelPreload.preloadNextAnswer();
              });
            }, 1000); */
        }
    });
}
__decorate([
    action.bound
], DirectivePoseQuestion.prototype, "poseNextAnswerInLine", null);
__decorate([
    action.bound
], DirectivePoseQuestion.prototype, "poseNextReward", null);
__decorate([
    action.bound
], DirectivePoseQuestion.prototype, "poseAnswer", null);
